<div class="w-full py-3 px-4">
  <!-- Title + Tabs Section -->
  <div class="flex flex-col sm:flex-row items-center justify-between mb-4">
    <!-- Title Section -->
    <div class="flex items-center gap-2 mb-3 sm:mb-0">
      <svg class="size-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_848_1764" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
          <rect width="24" height="24" fill="#C19725" />
        </mask>
        <g mask="url(#mask0_848_1764)">
          <path d="M16 22L6 12L16 2L17.775 3.775L9.55 12L17.775 20.225L16 22Z" fill="#C19725" />
        </g>
      </svg>
      <img class="size-6 sm:size-8 lg:size-10" src="/assets/images/raw-metal/raw-metal.png" alt="Raw Metal">
      <span class="font-semibold text-sm sm:text-base lg:text-xl text-444">
        Kalakaar Account Management
      </span>
    </div>

    <!-- Tabs (Aligned to Right) -->
    <div class="flex justify-end w-full sm:w-auto">
      <div class="flex">
        <button
          (click)="activeTab = 'account'"
          [ngClass]="{
            'bg-c19725 text-white border-c19725': activeTab === 'account',
            'text-gray-700 hover:bg-[#f6f1cb]': activeTab !== 'account'
          }"
          class="flex-1 px-4 py-2 rounded-l border border-gray-300 text-sm sm:text-base transition"
        >
          Account
        </button>

        <button
          (click)="activeTab = 'assets'"
          [ngClass]="{
            'bg-c19725 text-white border-c19725': activeTab === 'assets',
            'text-gray-700 hover:bg-[#f6f1cb]': activeTab !== 'assets'
          }"
          class="flex-1 px-4 py-2 rounded-r border border-gray-300 text-sm sm:text-base transition"
        >
          Assets
        </button>
      </div>
    </div>
  </div>

  <!-- Content Section -->
  <div class="mt-4">
    <ng-container [ngSwitch]="activeTab">
      <app-kalakar-account *ngSwitchCase="'account'"></app-kalakar-account>
      <app-assets *ngSwitchCase="'assets'"></app-assets>
    </ng-container>
  </div>
</div>
